<!-- [팝업] 선택 항목 구성 -->
<template>
  <b-modal
    v-model="showEditor"
    cancel-variant="outline-secondary"
    centered
    ok-title="적용"
    cancel-title="취소"
    size="lg"
    :title="title"
    no-close-on-esc
    no-close-on-backdrop
    @ok.prevent="submit()"
    @close.prevent="close()"
    @cancel.prevent="close()"
  >
    <div
      v-if="description"
      class="p-1"
    >
      <b-row>
        <b-col
          cols="12"
          md="12"
          class="d-flex justify-content-center"
        >
          <h5>{{ description }}</h5>
        </b-col>
      </b-row>
      <!-- <b-row class="my-1">
        <b-col
          cols="12"
          md="12"
          class="d-flex justify-content-center"
        >
          콘텐츠 내용 입력입니다.
        </b-col>
      </b-row> -->
    </div>
    <b-row>
      <b-form-textarea
        v-model="bindText"
        :value="text"
        rows="12"
      />
    </b-row>
  </b-modal>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
  },

  props: {
    showEditor: {
      type: Boolean,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },

  setup(props, { emit }) {
    watch(() => props.text, newVal => {
      bindText.value = newVal.indexOf('empty') !== -1 ? '' : newVal
    })

    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }

      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    const bindText = ref('')

    const close = () => {
      emit('close', null)
    }

    const submit = () => {
      if (!bindText.value) {
        pushToast('warning', '내용을 입력하세요.')
        return
      }

      emit('close', bindText.value)
    }

    return {
      bindText,
      close,
      submit,
    }
  },
}
</script>
